import { useState, useEffect, ReactElement } from "react";
import { Dimensions } from "react-native";

interface MediaQueryProps {
  minWidth?: number;
  maxWidth?: number;
  minHeight?: number;
  maxHeight?: number;
  children: ReactElement;
}

export default function MediaQuery({
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  children,
}: MediaQueryProps) {
  // Component to hide/show child components based on screen dimensions.
  const [window, setWindow] = useState(Dimensions.get("window"));

  useEffect(() => {
    const _handleDimensionsChange = () => {
      setWindow(Dimensions.get("window"));
    };
    Dimensions.addEventListener("change", _handleDimensionsChange);
    return () => {
      Dimensions.removeEventListener("change", _handleDimensionsChange);
    };
  }, []);

  const isInInterval = (value: number, min?: number, max?: number) => {
    return (
      (min === undefined || value >= min) && (max === undefined || value <= max)
    );
  };

  const { width, height } = window;
  const passesQuery =
    isInInterval(width, minWidth, maxWidth) &&
    isInInterval(height, minHeight, maxHeight);
  if (passesQuery) {
    return children;
  }
  return null;
}
